import * as ActionTypes from "../constants/ActionTypes";

// **************************************************************************************************************
export const resellersReducer = (state = {}, action) => {
    switch (action.type) {
        case ActionTypes.RESELLERS_SUCCESS:
            return Object.assign({}, state, action.response.entities && action.response.entities.reseller)
        default:
            return state
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/Resellers.js
 **/